import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { CompanyType } from '@/types/company';

export function useCompanyType(companyId: number | string | null | undefined) {
  const [companyType, setCompanyType] = useState<CompanyType | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchCompanyType() {
      if (!companyId) {
        setCompanyType(null);
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);

        const { data, error: fetchError } = await supabase
          .from('companies')
          .select('company_type')
          .eq('id', companyId)
          .maybeSingle();

        if (fetchError) {
          console.error('Error fetching company type:', fetchError);
          setError(new Error(fetchError.message));
          setCompanyType(null);
          return;
        }

        setCompanyType((data?.company_type as CompanyType) || null);
      } catch (err) {
        console.error('Unexpected error fetching company type:', err);
        setError(err instanceof Error ? err : new Error('Unknown error'));
        setCompanyType(null);
      } finally {
        setIsLoading(false);
      }
    }

    fetchCompanyType();
  }, [companyId]);

  return { companyType, isLoading, error };
}

